import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as i18nActions from "../../redux/actions/i18nActions";

import moment from "moment";
import momentTz from "moment-timezone";
import "moment/locale/da";
import { has } from "lodash";

// i18n library
import { textTranslate, translate } from "../../utils/i18n";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
// Add export module to highChart
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

class HighChartsComp extends Component {
  constructor(props) {
    super(props);
    if (!localStorage.getItem("invisibleLegendItems")) {
      localStorage.setItem("invisibleLegendItems", JSON.stringify([]));
    }
    moment.locale(this.props.language);
    this.state = {
      invisibleLegendItems: [],
      sensorsMetaObj: [],
      chartConfig: {
        chart: {
          type: "area",
          zoomType: "x",
          panning: true,
          panKey: "shift",
          spacingTop: 30,
          height: 550,
          scrollablePlotArea: {
            // minWidth: 600
          },
        },

        title: {
          text: " ",
        },
        subtitle: {
          text: " ",
        },

        yAxis: {
          title: {
            text: " ",
          },
        },

        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
        },
        xAxis: {
          type: "datetime",
          tickPixelInterval: 50,

          dateTimeLabelFormats: {
            millisecond: "%H:%M:%S.%L",
            second: "%H:%M:%S",
            minute: "%H:%M",
            hour: "%H:%M",
            day: "%e. %b",
            week: "%e. %b",
            month: "%b '%y",
            year: "%Y",
          },
        },
        series: [
          {
            dataGrouping: {
              enabled: false,
            },
          },
        ],
        time: {
          time: "",
          getTimezoneOffset: function (timestamp) {
            var zone = momentTz.tz.guess(),
              timezoneOffset = -moment.tz(timestamp, zone).utcOffset();

            return timezoneOffset;
          },
        },

        plotOptions: {
          series: {
            marker: {
              enabledThreshold: 5,
            },
            legendItemClick: this.handleLegendItemClick,
            events: { legendItemClick: this.handleLegendItemClick },
          },
        },

        lang: {
          loading: "Loading...",
          months: moment.months(),
          weekdays: moment.weekdays(),
          shortMonths: moment.monthsShort(),
        },
      },
    };
  }

  handleLegendItemClick({ target }) {
    if (localStorage.getItem("invisibleLegendItems") && "name" in target && target.name) {
      const invisibleLegendItemsArr = JSON.parse(localStorage.getItem("invisibleLegendItems"));
      const legendExist = invisibleLegendItemsArr.find((item) => item === target.name);

      if (legendExist) {
        localStorage.setItem(
          "invisibleLegendItems",
          JSON.stringify(invisibleLegendItemsArr.filter((item) => item !== legendExist))
        );
      } else {
        localStorage.setItem("invisibleLegendItems", JSON.stringify([...invisibleLegendItemsArr, target.name]));
      }
    } else if ("name" in target && target.name) {
      localStorage.setItem("invisibleLegendItems", JSON.stringify([target.name]));
    }
  }

  calculatingOverFlowThreshold(sensorData) {
    const boundaryDistance = sensorData.properties.boundary_distance;
    const overFlowThreshold = sensorData.properties.overFlowThreshold;
    const elevation = sensorData.properties.elevation;
    return this.props.isCalculatingElevation
      ? boundaryDistance - overFlowThreshold
      : parseFloat((boundaryDistance - overFlowThreshold) / 100 + elevation);
  }

  formatDataFunctionType(functionType) {
    switch (functionType) {
      case "continuous":
        return "spline";
      case "discrete":
        return "column";
      case "step":
        return "line";
      default:
        return "spline";
    }
  }

  prepareData() {
    let data = [];
    let sensorMetaObj = [];
    let seriesArr = [],
      sensorsArr = [];
    const _raw_data = this.props._loc_data && this.props._loc_data.length > 0 ? this.props._loc_data : this.props.data;

    if (_raw_data.length > 0) {
      sensorsArr = [];
      for (let sensorIndex = 0; sensorIndex < _raw_data.length; sensorIndex++) {
        seriesArr = [];
        const sensorDataPoints = _raw_data[sensorIndex];

        sensorMetaObj.push({
          sensorData:
            this.props.selectedDevices && this.props.selectedDevices[sensorIndex].length > 0
              ? this.props.selectedDevices[sensorIndex]
              : this.props.selectedDevices[sensorIndex],
        });
        let batteryLevelIndex = -1;
        if (
          sensorMetaObj &&
          sensorMetaObj[sensorIndex] &&
          sensorMetaObj[sensorIndex].sensorData &&
          sensorMetaObj[sensorIndex].sensorData.device_model &&
          sensorMetaObj[sensorIndex].sensorData.device_model.data_model
        )
          batteryLevelIndex = sensorMetaObj[sensorIndex]?.sensorData?.device_model?.data_model.findIndex(
            (model) => model.unit.slug === "batteryLevel"
          );

        sensorMetaObj[sensorIndex].lastBatteryLevel = 0;

        if (
          batteryLevelIndex !== -1 &&
          _raw_data[sensorIndex].length &&
          sensorDataPoints[_raw_data[sensorIndex].length - 1].hasOwnProperty("data") &&
          sensorDataPoints[_raw_data[sensorIndex].length - 1].data[batteryLevelIndex]
        ) {
          sensorMetaObj[sensorIndex].lastBatteryLevel =
            sensorDataPoints[_raw_data[sensorIndex].length - 1].data[batteryLevelIndex].v;
        }
        const sensor = _raw_data[sensorIndex];
        for (let measurementIndex = 0; measurementIndex < sensor.length; measurementIndex++) {
          const measurement = sensor[measurementIndex];
          if (measurement.hasOwnProperty("ts")) measurement.time = measurement.ts;
          if (measurement.data) {
            for (let readingIndex = 0; readingIndex < measurement.data.length; readingIndex++) {
              // seriesArr[readingIndex] = []
              const reading = measurement.data[readingIndex];
              if (readingIndex !== batteryLevelIndex) {
                if (seriesArr[readingIndex]) {
                  seriesArr[readingIndex].data.push([new Date(measurement.time).getTime(), reading.v]);
                  seriesArr[readingIndex].maxValue = Math.max(seriesArr[readingIndex].maxValue, Number(reading.v));
                  seriesArr[readingIndex].minValue = Math.min(seriesArr[readingIndex].minValue, Number(reading.v));
                  //type: 'column',
                } else {
                  let sensorName =
                    sensorMetaObj[sensorIndex].sensorData.device +
                    " - " +
                    sensorMetaObj[sensorIndex].sensorData.device_model.data_model[readingIndex].unit.name +
                    (sensorMetaObj[sensorIndex].sensorData.device_model.data_model[readingIndex].unit.value ? " (" : " ") +
                    sensorMetaObj[sensorIndex].sensorData.device_model.data_model[readingIndex].unit.value +
                    (sensorMetaObj[sensorIndex].sensorData.device_model.data_model[readingIndex].unit.value ? ") " : " ") +
                    " <br/>" +
                    sensorMetaObj[sensorIndex].sensorData.name +
                    " <br/>";

                  let isVisible = this.handleIsInvisibleLegendItems(sensorName);

                  seriesArr[readingIndex] = {
                    lineWidth: 2,
                    maxValue: reading.v,
                    minValue: 0,
                    visible: !isVisible,
                    type: this.formatDataFunctionType(
                      sensorMetaObj[sensorIndex].sensorData.device_model.data_model[readingIndex].data_type
                    ),
                    measurement_unit_value:
                      sensorMetaObj[sensorIndex].sensorData.device_model.data_model[readingIndex].unit.value,
                    name: sensorName,

                    data: [[new Date(measurement.time).getTime(), reading.v]],
                    step: !!(
                      this.formatDataFunctionType(
                        sensorMetaObj[sensorIndex].sensorData.device_model.data_model[readingIndex].data_type
                      ) === "line"
                    ),
                    tooltip: {
                      valueSuffix:
                        (sensorMetaObj[sensorIndex].sensorData.device_model.data_model[readingIndex].unit.value ? " (" : " ") +
                        sensorMetaObj[sensorIndex].sensorData.device_model.data_model[readingIndex].unit.value +
                        (sensorMetaObj[sensorIndex].sensorData.device_model.data_model[readingIndex].unit.value ? ") " : " "),
                    },
                  };
                }
              }
            }
          }
        }
        sensorMetaObj[sensorIndex].axiesNumber = seriesArr.length;
        sensorsArr[sensorIndex] = [...seriesArr];
      }

      data = sensorsArr;
    } else {
      data = [];
    }
    return { data, sensorMetaObj };
  }

  handleIsInvisibleLegendItems(sensorName) {
    if (localStorage.getItem("invisibleLegendItems")) {
      return JSON.parse(localStorage.getItem("invisibleLegendItems")).find((item) => item == sensorName) !== undefined;
    }
    {
      return true;
    }
  }
  componentDidMount() {
    if (this.props.selectedDevices.length > 0) {
      let newData = this.prepareData();
      if (newData.data.length > 0) {
        /**  * Bulid Hicharts subtitle  */

        /** * Bulid Hicharts yAxis  */
        const d = this.createHighChartsYAxis(newData);
        const yAxis = d.yAxis;
        newData = { ...d.newData };
        /** * Bulid Hicharts series */
        const series = newData.data.flat();

        let sensorWithOverFlowThreshold = newData.sensorMetaObj.filter(
          (sensor) => has(sensor, "sensorData.properties.overFlowThreshold") && sensor.sensorData.properties.overFlowThreshold > 0
        );
        if (sensorWithOverFlowThreshold.length > 0 && series.length && series[0].data.length) {
          series.push({
            name: sensorWithOverFlowThreshold[0].sensorData.device + ") overFlow Threshold",
            color: "#ff0000",
            type: "spline",
            marker: {
              enabled: true,
              radius: 1,
            },
            data: [
              [series[0].data[0][0], this.calculatingOverFlowThreshold(sensorWithOverFlowThreshold[0].sensorData)],
              [
                series[series.length - 1].data[series[series.length - 1].data.length - 1][0],
                this.calculatingOverFlowThreshold(sensorWithOverFlowThreshold[0].sensorData),
              ],
            ],
          });
        }

        this.setState({
          chartConfig: {
            yAxis,
            series: [...series],
            reflow: true,
            exporting: {
              showTable: false,
              csv: {
                dateFormat: "%Y-%m-%d %H:%M:%S",
              },
              chartOptions: {
                // specific options for the exported image
                plotOptions: {
                  series: {
                    dataLabels: {
                      enabled: false,
                    },
                    marker: {
                      enabledThreshold: 5,
                    },
                  },
                },
              },
              fallbackToExportServer: false,
            },
          },
          sensorsMetaObj: [...newData.sensorMetaObj],
        });
      }
    }
  }
  /**
   * Not used For now
   */
  createHighChartsSubTitle(sensorMetaObj) {
    let subtitle = "";
    sensorMetaObj.length <= 1
      ? (subtitle = "(" + sensorMetaObj[0].sensorData.device + ") " + sensorMetaObj[0].sensorData.name)
      : sensorMetaObj.forEach((sersor) => {
          subtitle = subtitle + ", (" + sersor.sensorData.device + ") " + sersor.sensorData.name;
          subtitle = subtitle.slice(1);
        });
    return subtitle;
  }

  createHighChartsYAxis(newData) {
    let yAxis = [];
    for (let sensorIndex = 0; sensorIndex < newData.sensorMetaObj.length; sensorIndex++) {
      const sensor = newData.sensorMetaObj[sensorIndex];

      for (let yAxisIndex = 0; yAxisIndex < newData.sensorMetaObj[sensorIndex].axiesNumber; yAxisIndex++) {
        const measurementUnit = sensor.sensorData.device_model.data_model[yAxisIndex].unit;

        if (yAxis.length <= 0) {
          yAxis.push({
            measurement_unit_value: measurementUnit.value,
            labels: {
              format: "{value} " + measurementUnit.value,
              style: {},
            },
            title: {
              text: "",
              style: {},
            },
            opposite: false,
            showEmpty: true,
          });
        } else if (!yAxis.find((axis) => measurementUnit.value === axis.measurement_unit_value)) {
          yAxis.push({
            measurement_unit_value: measurementUnit.value,
            labels: {
              format: "{value} " + measurementUnit.value,
              style: {},
            },
            title: {
              text: " ",
              style: {},
            },
            opposite: true,
            showEmpty: true, // default is true
            softMax: measurementUnit.value === "%" ? 100 : 1,
            softMin: 0,
            max: newData.data[sensorIndex][yAxisIndex].maxValue,
            min: newData.data[sensorIndex][yAxisIndex].minValue,
          });
        }
        newData.data[sensorIndex][yAxisIndex].yAxis = yAxis.findIndex(
          (ax) => newData.data[sensorIndex][yAxisIndex].measurement_unit_value === ax.measurement_unit_value
        );
      }
    }

    return { yAxis, newData };
  }

  componentDidUpdate(prevProps) {
    if (this.props.language !== prevProps.language) {
      moment.locale(this.props.language);
      this.setState({
        ...this.state,
        chartConfig: {
          ...this.state.chartConfig,
          lang: {
            months: moment.months(),
            weekdays: moment.weekdays(),
            shortMonths: moment.monthsShort(),
          },
        },
      });
    }
  }
  render() {
    moment.locale(this.props.language);
    Highcharts.setOptions({
      lang: {
        loading: "Loading...",
        months: moment.months(),
        weekdays: moment.weekdays(),
        shortMonths: moment.monthsShort(),
        exportButtonTitle: textTranslate("exportButtonTitle"),
        printButtonTitle: textTranslate("printButtonTitle"),
        rangeSelectorFrom: textTranslate("rangeSelectorFrom"),
        rangeSelectorTo: textTranslate("rangeSelectorTo"),
        rangeSelectorZoom: textTranslate("rangeSelectorZoom"),
        downloadPNG: textTranslate("downloadPNG"),
        downloadJPEG: textTranslate("downloadJPEG"),
        downloadPDF: textTranslate("downloadPDF"),
        downloadSVG: textTranslate("downloadSVG"),
        viewFullscreen: textTranslate("viewFullscreen"),
      },
      exporting: {
        showTable: false,
        csv: {
          dateFormat: "%Y-%m-%d %H:%M:%S",
        },
        filename: "iot.klimator.dk",
        buttons: {
          contextButton: {
            menuItems: [
              "viewFullscreen",
              "printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadSVG",
              "separator",
              "downloadPDF",
              "downloadCSV",
              "downloadXLS",
            ],
          },
        },
      },
    });

    return (
      <React.Fragment>
        {!!this.state.chartConfig && (
          <React.Fragment>
            <HighchartsReact highcharts={Highcharts} options={this.state.chartConfig} />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  devices: state.devicesReducer.devices,
  selectedDevices: state.devicesReducer.selectedDevices,
  data: state.devicesReducer.data,
  isFetchingDeviceData: state.devicesReducer.isFetchingDeviceData,
  isCalculatingElevation: state.devicesReducer.isCalculatingElevation,
  ability: state.usersReducer.ability,
  language: state.i18nReducer.language,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...i18nActions }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(HighChartsComp);
